import { store } from '../store';
import { setActiveSkillIds } from '../store/slices/skillSlice';
import { setNewTaskPromptMode, setSelectedDesktopClient } from '../store/slices/coworkSlice';
import { clearSelection } from '../store/slices/quickActionSlice';
import { authService } from './auth';
import { coworkService } from './cowork';
import { conversationDraftKey, conversationDrafts } from './conversationDraft';

/**
 * 将当前已启用的 Web 技能带入新对话草稿；不发送消息、不安装或自动启用技能。
 * @param skillId 当前账号技能的稳定 ID；每次执行重新校验，拒绝过期弹窗中的选择。
 * @param question 可选示例提问，追加到已有云端草稿并保留附件。
 * @returns 是否已准备成功；无账号、技能删除/停用时不改变任何会话或草稿。
 */
export function prepareSkillConversation(skillId: string, question = ''): boolean {
  const auth = authService.getAuthState();
  const skill = store.getState().skill.skills.find(item => item.id === skillId && item.enabled);
  if (!auth || !skill) return false;
  const key = conversationDraftKey(authService.getBaseUrl(), String(auth.user.id));
  const draft = conversationDrafts.read(key);
  const prompt = question.trim();
  // 技能库属于当前 Web Host。不能沿用另一台桌面设备的技能 ID 或本地文件工作目录。
  store.dispatch(setSelectedDesktopClient({ clientId: null }));
  store.dispatch(setNewTaskPromptMode('collaboration'));
  store.dispatch(clearSelection());
  coworkService.clearSession();
  store.dispatch(setActiveSkillIds([skillId]));
  if (prompt) conversationDrafts.write(key, draft.text.trim() ? `${draft.text}\n\n${prompt}` : prompt, draft.attachments);
  return true;
}
